import { useEffect, useState } from 'react';

export type Timer = {
  days: string;
  hours: string;
  minutes: string;
  seconds: string;
  timeUp: boolean;
  timerSet: boolean;
};

export const insertZero = (time: number, threshold: number = 10): string => {
  if (time < threshold) {
    return `0${time}`;
  }
  return `${time}`;
};

export const getSeconds = (date: string | Date): number => {
  return Math.round(new Date(date).getTime() / 1000 - new Date().getTime() / 1000);
};

export const getTimeLeft = (startDate: string | Date): Timer => {
  const secs = getSeconds(startDate);

  if (secs <= 0) {
    return {
      days: '00',
      hours: '00',
      minutes: '00',
      seconds: '00',
      timeUp: true,
      timerSet: true,
    };
  }
  const days = insertZero(Math.floor(secs / (3600 * 24)));
  const hours = insertZero(Math.floor((secs % (3600 * 24)) / 3600));
  const minutes = insertZero(Math.floor((secs % 3600) / 60));
  const seconds = insertZero(Math.floor((secs % 3600) % 60));

  return {
    days,
    hours,
    minutes,
    seconds,
    timeUp: false,
    timerSet: true,
  };
};

/**
 *
 * @param startDate if a string, expects a date in ISO 8601 format (ending with a Z)
 * @param startingMinutes self-explanatory
 * @returns object containing days, hours, minutes, seconds left, as well as booleans timeUp and timerSet
 */
export function useTimer(startDate: string | Date | null, startingMinutes = '05') {
  const [timer, setTimer] = useState({
    days: '00',
    hours: '00',
    minutes: startingMinutes,
    seconds: '00',
    timeUp: false,
    timerSet: false,
  });

  useEffect(() => {
    if (!startDate) {
      return;
    }
    const intervalId = setInterval(() => {
      const counterTimer = getTimeLeft(startDate);
      setTimer(counterTimer);
      if (timer.timeUp) {
        clearInterval(intervalId);
      }
    }, 1000);
    return () => {
      clearInterval(intervalId);
    };
  }, [startDate]);

  return timer;
}
